<template>
    <div class="cancel-filter cancel-filter-inline" v-if="getSelectedItems.length > 0">
        <div class="cancel-filter__items">
            <!-- view for all checkbox-->
            <div v-for="item in getSelectedItems">
                <span
                    v-if="item.VALUE"
                    class="cancel-filter__item"
                    @click="handlerDeleteElement(item)"
                >
                    <svg><use xlink:href="#svg-close"></use></svg>
                    {{item.VALUE}}
                </span>
                <!-- view for range price-->
                <span v-else class="cancel-filter__item" @click="handlerDeleteRange(item)">
                    <svg><use xlink:href="#svg-close"></use></svg>
                    {{item.printRange}}
                </span>
            </div>

            <button
                v-if="result.actions && result.actions.resetFilter"
                :href="result.actions.resetFilter.href"
                @click.prevent="$emit('resetFilter', result.actions.resetFilter.href)"
                class="cancel-filter__reset"
                type="reset"
                form="filter"
            >
                {{result.actions.resetFilter.text}}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CancelFilterInline',
    props: {
        result: {
            type: Object
        }
    },
    computed: {
        getSelectedItems() {
            const obj = this.result.ITEMS;
            let arr = [];

            for (let key in obj) {
                const subObj = obj[key].VALUES;
                if (key === '183') {
                    /** get string for price range**/
                    const range = {};
                    let newObj = {
                        ...obj[key]
                    }
                    for (let i in subObj) {
                        if (subObj[i].HTML_VALUE) {
                            range[i] = subObj[i].HTML_VALUE;
                        }
                    }
                    if (range.MIN && range.MAX) {
                        newObj.printRange = `от(нужен текст) ${range.MIN} до(нужен текст) ${range.MAX}`;
                    } else if (range.MIN) {
                        newObj.printRange = `от(нужен текст) ${range.MIN}`;
                    } else if (range.MAX) {
                        newObj.printRange = `до(нужен текст) ${range.MAX}`;
                    }
                    if (newObj.printRange) {
                        arr.push(newObj);
                    }
                } else if (obj[key].VALUES) {
                    /** get all checkbox **/
                    for (let i in subObj) {
                        if (subObj[i].CHECKED) {
                            arr.push(subObj[i]);
                        }
                    }
                }
            }
            return arr;
        },
    },
    methods: {
        handlerDeleteElement(item) {
            const el = this.$parent.$el.querySelector(`[name="${item.CONTROL_NAME}"]`);
            el.checked = false;
            this.$emit('handlerChangeData');
        },
        handlerDeleteRange(item) {
            const items = item.VALUES;
            for (let el in items) {
                let input = this.$parent.$el.querySelector(`[name="${items[el].CONTROL_NAME}"]`);
                input.value = '';
            }
            this.$emit('handlerChangeData');
        }
    }
}
</script>